import { Cog } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const EngineeringIcon = createLucideIcon(Cog);
